import { useTranslation } from "react-i18next";
import { CustomModal } from "../../../components/CustomModal";
import { MDBBtn } from "mdb-react-ui-kit";
import { useCallback, useEffect, useState } from "react";
import { TextInput } from "../../../components/core/inputs/TextInput";
import { Alert } from "../../../components/Alert";
import API from "../../../service/api";

export interface ChangeSNModalProps {
    machineId: number;
    open: boolean;
    onDone: () => void;
    onClose: () => void;
}
export const ChangeSNModal = ({machineId, open, onDone, onClose}: ChangeSNModalProps) => {
    const { t } = useTranslation();
    const [sn, setSN] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const confirm = useCallback(() => {
        if (sn.length == 24) {
            setLoading(true);
            API.POST(`/api/admmachines/${machineId}/changeSN`, {sn})
                .then(() => onDone())
                .catch(err => setError(err.message))
                .finally(() => setLoading(false));
        }
    }, [onDone, sn]);

    useEffect(() => {
        if (!open) return;
        setSN("");
    }, [open]);

    return (
        <CustomModal
            open={open}
            onClose={onClose}
            title={t('machine:changeSN')}
            footer={(
                <>
                    <MDBBtn color="secondary" onClick={onClose}>{t('cancel')}</MDBBtn>
                    <MDBBtn color="danger" onClick={confirm} disabled={sn.length !== 24 || loading}>{t('confirm')}</MDBBtn>
                </>
            )}
        >
            <div className="d-flex flex-column">
                <TextInput
                    value={sn}
                    onValueChange={setSN}
                />
                <Alert message={error} type="danger"/>
            </div>
        </CustomModal>
    )
}